module.exports = __webpack_public_path__ + "static/media/Jorah Mormont 3.67f931b8.jpg";